// src/i18n/index.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import he from './he.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    he: { translation: he },
  },
  lng: 'he', // default language
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
